// extracted by mini-css-extract-plugin
module.exports = {"option":"ShopSelect_option__2qsyx","label":"ShopSelect_label__35bBr","description":"ShopSelect_description__3KFmP"};